module.exports = __webpack_public_path__ + "img/annotation-paragraph.da51c081.svg";